interface AiMessageBubbleProps {
  content: string;
}

export function AiMessageBubble({ content }: AiMessageBubbleProps) {
  return (
    <div className="min-w-0 max-w-full self-start">
      <p className="whitespace-pre-wrap break-words text-[14px] font-normal leading-[22.4px] text-nv-text-primary">
        {content}
      </p>
    </div>
  );
}
